import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const SONUC_RENK: Record<string, string> = { 'Uygun': '#22c55e', 'Uygun Değil': '#ef4444', 'Şartlı': '#f59e0b' };
const SONUC_RGB: Record<string, string> = { 'Uygun': '34,197,94', 'Uygun Değil': '239,68,68', 'Şartlı': '245,158,11' };

@Component({
  selector: 'kalite-olcum-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--kalite-olcum" [style.--accent]="sonucRenk()" [style.--accent-rgb]="sonucRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:7s;--x:14%;--y:24%"></span><span class="gc-p" style="--d:10s;--x:76%;--y:36%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:42%;--y:66%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">KALİTE ÖLÇÜMÜ</div>
        <div class="ko-ust">
          <div class="ko-nokta gc-baslik-ana">{{ p()?.olcumNoktasi || 'Ölçüm' }}</div>
          <div class="ko-sonuc-badge">{{ p()?.sonuc || 'Uygun' }}</div>
        </div>
        <div class="ko-deger-alan">
          <div class="ko-deger">{{ p()?.olculenDeger ?? '-' }}</div>
          <div class="ko-tolerans">
            @if (p()?.toleransAlt != null || p()?.toleransUst != null) {
              <span class="ko-tol-etiket">TOL</span>
              <span>{{ p()?.toleransAlt ?? '-' }} / {{ p()?.toleransUst ?? '-' }}</span>
            }
          </div>
        </div>
        <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu" [style.width.%]="gorunur() ? toleransYuzde() : 0" [style.background]="'linear-gradient(90deg, ' + sonucRenk() + ', color-mix(in srgb, ' + sonucRenk() + ' 60%, #fff))'"></div></div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 55 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #059669; --accent-rgb: 5,150,105; }
    .ko-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .ko-nokta { font-size: 12px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
    .ko-sonuc-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); flex-shrink: 0; animation: badge-pulse 2s ease-in-out infinite; }
    .ko-deger-alan { display: flex; align-items: baseline; gap: 12px; }
    .ko-deger { font-size: 22px; font-weight: 900; color: var(--accent); font-variant-numeric: tabular-nums; text-shadow: 0 0 10px rgba(var(--accent-rgb),.3); }
    .ko-tolerans { font-size: 10px; color: var(--py-metin-ikincil, #64748b); font-variant-numeric: tabular-nums; }
    .ko-tol-etiket { font-size: 7px; font-weight: 700; letter-spacing: .1em; color: var(--py-metin-ucuncul, #4a5568); margin-right: 4px; }
  `],
})
export class KaliteOlcumKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  sonucRenk = computed(() => SONUC_RENK[this.p()?.sonuc] || '#22c55e');
  sonucRgb = computed(() => SONUC_RGB[this.p()?.sonuc] || '34,197,94');
  toleransYuzde = computed(() => {
    const d = this.p()?.olculenDeger;
    const alt = this.p()?.toleransAlt;
    const ust = this.p()?.toleransUst;
    if (d == null || alt == null || ust == null || ust === alt) return 50;
    return Math.min(100, Math.max(0, ((d - alt) / (ust - alt)) * 100));
  });
}
